var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBearCallSpread(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 28H58",
    stroke: "#E6E6E6",
    strokeLinecap: "round",
    strokeDasharray: "4 5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 22H7V17.5H26.5L42.5 33.5H36L24.5 22Z",
    fill: "#12B16E",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.75 38.5L36.5 28H30L44.4986 41.9987L45.4999 43H61.4999V38.5H47.75Z",
    fill: "#E94C69"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4994 28V27.5H36.6965L36.8406 27.6345L36.4994 28ZM47.7494 38.5V39H47.5523L47.4082 38.8655L47.7494 38.5ZM29.9994 28L29.6521 28.3597L28.7617 27.5H29.9994V28ZM44.498 41.9987L44.8454 41.6389L44.8516 41.6451L44.498 41.9987ZM45.4993 43V43.5H45.2922L45.1458 43.3536L45.4993 43ZM61.4993 43H61.9993V43.5H61.4993V43ZM61.4993 38.5V38H61.9993V38.5H61.4993ZM36.8406 27.6345L48.0906 38.1345L47.4082 38.8655L36.1582 28.3655L36.8406 27.6345ZM29.9994 27.5H36.4994V28.5H29.9994V27.5ZM44.1507 42.3584L29.6521 28.3597L30.3467 27.6403L44.8454 41.6389L44.1507 42.3584ZM45.1458 43.3536L44.1445 42.3522L44.8516 41.6451L45.8529 42.6464L45.1458 43.3536ZM61.4993 43.5H45.4993V42.5H61.4993V43.5ZM61.9993 38.5V43H60.9993V38.5H61.9993ZM47.7494 38H61.4993V39H47.7494V38Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7 12.5V53.5",
    stroke: "#E6E6E6",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBearCallSpread);
export default __webpack_public_path__ + "static/media/bear Call Spread.42e6766bde96db6becd430daa636d832.svg";
export { ForwardRef as ReactComponent };